export const TOGGLE_BUS_SEAT_LAYOUT = 'SEAT_LAYOUT/TOGGLE_BUS_SEAT_LAYOUT';
export const UPDATE_SELECTED_BUS_INFO ='SEAT_LAYOUT/UPDATE_SELECTED_BUS_INFO';
export const UPDATE_SELECTED_BUS_DATA = 'SEAT_LAYOUT/UPDATE_SELECTED_BUS_DATA';
export const UPDATE_RATING_REVIEW_DATA = 'SEAT_LAYOUT/UPDATE_RATING_REVIEW_DATA';
export const UPDATE_BUS_DETAILS ='SEAT_LAYOUT/UPDATE_BUS_DETAILS'
